<template>
  <div class="scope-of-application">
    <div class="block-content">
      <block-title :en="section.title.en" :title="section.title.value" :sub="section.title.sub"></block-title>
    </div>
    <case-list :list="section.list"></case-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['globalData']),
    section() {
      return this.globalData['rail-transit-equipment-management-system']?.scopeOfApplication || { title: {}, list: [] };
    }
  }
};
</script>

<style lang="scss" scoped>
.scope-of-application {
  padding: 80px 0;
  background: #ffffff;

  * {
    box-sizing: border-box;
  }

  ::v-deep .list {
    margin-top: 60px;
  }

  ::v-deep .item {
    overflow: hidden;
    border-radius: 8px;
  }
}
</style>
